import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty2 from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.math.hypot.js";
import { V, c as computeRubberband } from './maths-b2a210f4.esm.js';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var EVENT_TYPE_MAP = {
  pointer: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  mouse: {
    start: 'down',
    change: 'move',
    end: 'up'
  },
  touch: {
    start: 'start',
    change: 'move',
    end: 'end'
  },
  gesture: {
    start: 'start',
    change: 'change',
    end: 'end'
  }
};

function capitalize(string) {
  if (!string) return '';
  return string[0].toUpperCase() + string.slice(1);
}

function toHandlerProp(device) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var deviceProps = EVENT_TYPE_MAP[device];
  var actionKey = deviceProps ? deviceProps[action] || action : action;
  return 'on' + capitalize(device) + capitalize(actionKey) + (capture ? 'Capture' : '');
}

var pointerCaptureEvents = ['gotpointercapture', 'lostpointercapture'];

function parseProp(prop) {
  var eventKey = prop.substring(2).toLowerCase();
  var passive = !!~eventKey.indexOf('passive');
  if (passive) eventKey = eventKey.replace('passive', '');
  var captureKey = pointerCaptureEvents.includes(eventKey) ? 'capturecapture' : 'capture';
  var capture = !!~eventKey.indexOf(captureKey);
  if (capture) eventKey = eventKey.replace('capture', '');
  return {
    device: eventKey,
    capture: capture,
    passive: passive
  };
}

function toDomEventType(device) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var deviceProps = EVENT_TYPE_MAP[device];
  var actionKey = deviceProps ? deviceProps[action] || action : action;
  return device + actionKey;
}

function isTouch(event) {
  return 'touches' in event;
}

function getCurrentTargetTouchList(event) {
  return Array.from(event.touches).filter(function (e) {
    var _event$currentTarget, _event$currentTarget$;

    return e.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e.target));
  });
}

function getTouchList(event) {
  return event.type === 'touchend' ? event.changedTouches : event.targetTouches;
}

function getValueEvent(event) {
  return isTouch(event) ? getTouchList(event)[0] : event;
}

function distanceAngle(P1, P2) {
  var dx = P2.clientX - P1.clientX;
  var dy = P2.clientY - P1.clientY;
  var cx = (P2.clientX + P1.clientX) / 2;
  var cy = (P2.clientY + P1.clientY) / 2;
  var distance = Math.hypot(dx, dy);
  var angle = -(Math.atan2(dx, dy) * 180) / Math.PI;
  var origin = [cx, cy];
  return {
    angle: angle,
    distance: distance,
    origin: origin
  };
}

function touchIds(event) {
  return getCurrentTargetTouchList(event).map(function (touch) {
    return touch.identifier;
  });
}

function touchDistanceAngle(event, ids) {
  var _Array$from$filter = Array.from(event.touches).filter(function (touch) {
    return ids.includes(touch.identifier);
  }),
      _Array$from$filter2 = _slicedToArray(_Array$from$filter, 2),
      P1 = _Array$from$filter2[0],
      P2 = _Array$from$filter2[1];

  return distanceAngle(P1, P2);
}

function pointerId(event) {
  var valueEvent = getValueEvent(event);
  return isTouch(event) ? valueEvent.identifier : valueEvent.pointerId;
}

function pointerValues(event) {
  var valueEvent = getValueEvent(event);
  return [valueEvent.clientX, valueEvent.clientY];
}

var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

function wheelValues(event) {
  var deltaX = event.deltaX,
      deltaY = event.deltaY,
      deltaMode = event.deltaMode;

  if (deltaMode === 1) {
    deltaX *= LINE_HEIGHT;
    deltaY *= LINE_HEIGHT;
  } else if (deltaMode === 2) {
    deltaX *= PAGE_HEIGHT;
    deltaY *= PAGE_HEIGHT;
  }

  return [deltaX, deltaY];
}

function scrollValues(event) {
  var _ref, _ref2;

  var _event$currentTarget2 = event.currentTarget,
      scrollX = _event$currentTarget2.scrollX,
      scrollY = _event$currentTarget2.scrollY,
      scrollLeft = _event$currentTarget2.scrollLeft,
      scrollTop = _event$currentTarget2.scrollTop;
  return [(_ref = scrollX !== null && scrollX !== void 0 ? scrollX : scrollLeft) !== null && _ref !== void 0 ? _ref : 0, (_ref2 = scrollY !== null && scrollY !== void 0 ? scrollY : scrollTop) !== null && _ref2 !== void 0 ? _ref2 : 0];
}

function getEventDetails(event) {
  var payload = {};
  if ('buttons' in event) payload.buttons = event.buttons;

  if ('shiftKey' in event) {
    var shiftKey = event.shiftKey,
        altKey = event.altKey,
        metaKey = event.metaKey,
        ctrlKey = event.ctrlKey;
    Object.assign(payload, {
      shiftKey: shiftKey,
      altKey: altKey,
      metaKey: metaKey,
      ctrlKey: ctrlKey
    });
  }

  return payload;
}

function call(v) {
  if (typeof v === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return v.apply(void 0, args);
  } else {
    return v;
  }
}

function noop() {}

function chain() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  if (fns.length === 0) return noop;
  if (fns.length === 1) return fns[0];
  return function () {
    var result;

    var _iterator = _createForOfIteratorHelper(fns),
        _step2;

    try {
      for (_iterator.s(); !(_step2 = _iterator.n()).done;) {
        var fn = _step2.value;
        result = fn.apply(this, arguments) || result;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return result;
  };
}

function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}

var BEFORE_LAST_KINEMATICS_DELAY = 32;

var Engine = /*#__PURE__*/function () {
  function Engine(ctrl, args, key) {
    _classCallCheck(this, Engine);

    this.ctrl = ctrl;
    this.args = args;
    this.key = key;

    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init) this.init();
      this.reset();
    }
  }

  _createClass(Engine, [{
    key: "state",
    get: function get() {
      return this.ctrl.state[this.key];
    },
    set: function set(state) {
      this.ctrl.state[this.key] = state;
    }
  }, {
    key: "shared",
    get: function get() {
      return this.ctrl.state.shared;
    }
  }, {
    key: "eventStore",
    get: function get() {
      return this.ctrl.gestureEventStores[this.key];
    }
  }, {
    key: "timeoutStore",
    get: function get() {
      return this.ctrl.gestureTimeoutStores[this.key];
    }
  }, {
    key: "config",
    get: function get() {
      return this.ctrl.config[this.key];
    }
  }, {
    key: "sharedConfig",
    get: function get() {
      return this.ctrl.config.shared;
    }
  }, {
    key: "handler",
    get: function get() {
      return this.ctrl.handlers[this.key];
    }
  }, {
    key: "reset",
    value: function reset() {
      var state = this.state,
          shared = this.shared,
          ingKey = this.ingKey,
          args = this.args;
      shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
      state._step = [false, false];
      state.intentional = false;
      state._movement = [0, 0];
      state._distance = [0, 0];
      state._direction = [0, 0];
      state._delta = [0, 0];
      state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
      state.args = args;
      state.axis = undefined;
      state.memo = undefined;
      state.elapsedTime = 0;
      state.direction = [0, 0];
      state.distance = [0, 0];
      state.overflow = [0, 0];
      state._movementBound = [false, false];
      state.velocity = [0, 0];
      state.movement = [0, 0];
      state.delta = [0, 0];
      state.timeStamp = 0;
    }
  }, {
    key: "start",
    value: function start(event) {
      var state = this.state;
      var config = this.config;

      if (!state._active) {
        this.reset();
        this.computeInitial();
        state._active = true;
        state.target = event.target;
        state.currentTarget = event.currentTarget;
        state.lastOffset = config.from ? call(config.from, state) : state.offset;
        state.offset = state.lastOffset;
      }

      state.startTime = state.timeStamp = event.timeStamp;
    }
  }, {
    key: "computeValues",
    value: function computeValues(values) {
      var state = this.state;
      state._values = values;
      state.values = this.config.transform(values);
    }
  }, {
    key: "computeInitial",
    value: function computeInitial() {
      var state = this.state;
      state._initial = state._values;
      state.initial = state.values;
    }
  }, {
    key: "compute",
    value: function compute(event) {
      var state = this.state,
          config = this.config,
          shared = this.shared;
      state.args = this.args;
      var dt = 0;

      if (event) {
        state.event = event;
        if (config.preventDefault && event.cancelable) state.event.preventDefault();
        state.type = event.type;
        shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
        shared.locked = !!document.pointerLockElement;
        Object.assign(shared, getEventDetails(event));
        shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
        dt = event.timeStamp - state.timeStamp;
        state.timeStamp = event.timeStamp;
        state.elapsedTime = state.timeStamp - state.startTime;
      }

      if (state._active) {
        var _absoluteDelta = state._delta.map(Math.abs);

        V.addTo(state._distance, _absoluteDelta);
      }

      var _state$_movement = _slicedToArray(state._movement, 2),
          _m0 = _state$_movement[0],
          _m1 = _state$_movement[1];

      var _config$threshold = _slicedToArray(config.threshold, 2),
          t0 = _config$threshold[0],
          t1 = _config$threshold[1];

      var _step = state._step,
          values = state.values;

      if (config.hasCustomTransform) {
        if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && values[0];
        if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && values[1];
      } else {
        if (_step[0] === false) _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
        if (_step[1] === false) _step[1] = Math.abs(_m1) >= t1 && Math.sign(_m1) * t1;
      }

      state.intentional = _step[0] !== false || _step[1] !== false;
      if (!state.intentional) return;
      var movement = [0, 0];

      if (config.hasCustomTransform) {
        var _values2 = _slicedToArray(values, 2),
            v0 = _values2[0],
            v1 = _values2[1];

        movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
        movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
      } else {
        movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
        movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
      }

      if (this.intent) this.intent(movement);

      if (state._active && !state._blocked || state.active) {
        state.first = state._active && !state.active;
        state.last = !state._active && state.active;
        state.active = shared[this.ingKey] = state._active;

        if (event) {
          if (state.first) {
            if ('bounds' in config) state._bounds = call(config.bounds, state);
            if (this.setup) this.setup();
          }

          state.movement = movement;
          var previousOffset = state.offset;
          this.computeOffset();

          if (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY) {
            state.delta = V.sub(state.offset, previousOffset);
            var absoluteDelta = state.delta.map(Math.abs);
            V.addTo(state.distance, absoluteDelta);
            state.direction = state.delta.map(Math.sign);
            state._direction = state._delta.map(Math.sign);

            if (!state.first && dt > 0) {
              state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
            }
          }
        }
      }

      var _state$offset = _slicedToArray(state.offset, 2),
          ox = _state$offset[0],
          oy = _state$offset[1];

      var _state$_bounds = _slicedToArray(state._bounds, 2),
          _state$_bounds$ = _slicedToArray(_state$_bounds[0], 2),
          x0 = _state$_bounds$[0],
          x1 = _state$_bounds$[1],
          _state$_bounds$2 = _slicedToArray(_state$_bounds[1], 2),
          y0 = _state$_bounds$2[0],
          y1 = _state$_bounds$2[1];

      state.overflow = [ox < x0 ? -1 : ox > x1 ? 1 : 0, oy < y0 ? -1 : oy > y1 ? 1 : 0];
      state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
      state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
      var rubberband = state._active ? config.rubberband || [0, 0] : [0, 0];
      state.offset = computeRubberband(state._bounds, state.offset, rubberband);
      this.computeMovement();
    }
  }, {
    key: "emit",
    value: function emit() {
      var state = this.state;
      var shared = this.shared;
      var config = this.config;
      if (!state._active) this.clean();
      if ((state._blocked || !state.intentional) && !state._force && !config.triggerAllEvents) return;
      var memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, _defineProperty2({}, this.aliasKey, state.values)));
      if (memo !== undefined) state.memo = memo;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.eventStore.clean();
      this.timeoutStore.clean();
    }
  }]);

  return Engine;
}();

function selectAxis(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      dx = _ref4[0],
      dy = _ref4[1];

  var d = Math.abs(dx) - Math.abs(dy);
  if (d > 0) return 'x';
  if (d < 0) return 'y';
  return undefined;
}

function restrictVectorToAxis(v, axis) {
  switch (axis) {
    case 'x':
      v[1] = 0;
      break;

    case 'y':
      v[0] = 0;
      break;
  }
}

var CoordinatesEngine = /*#__PURE__*/function (_Engine) {
  _inherits(CoordinatesEngine, _Engine);

  var _super = _createSuper(CoordinatesEngine);

  function CoordinatesEngine() {
    var _this;

    _classCallCheck(this, CoordinatesEngine);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "aliasKey", 'xy');

    return _this;
  }

  _createClass(CoordinatesEngine, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(CoordinatesEngine.prototype), "reset", this).call(this);

      this.state.axis = undefined;
    }
  }, {
    key: "init",
    value: function init() {
      this.state.offset = [0, 0];
      this.state.lastOffset = [0, 0];
    }
  }, {
    key: "computeOffset",
    value: function computeOffset() {
      this.state.offset = V.add(this.state.lastOffset, this.state.movement);
    }
  }, {
    key: "computeMovement",
    value: function computeMovement() {
      this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
    }
  }, {
    key: "intent",
    value: function intent(v) {
      this.state.axis = this.state.axis || selectAxis(v);
      this.state._blocked = (this.config.lockDirection || !!this.config.axis) && !this.state.axis || !!this.config.axis && this.config.axis !== this.state.axis;
      if (this.state._blocked) return;

      if (this.config.axis || this.config.lockDirection) {
        restrictVectorToAxis(v, this.state.axis);
      }
    }
  }]);

  return CoordinatesEngine;
}(Engine);

var identity = function identity(v) {
  return v;
};

var DEFAULT_RUBBERBAND = 0.15;
var commonConfigResolver = {
  enabled: function enabled() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  },
  preventDefault: function preventDefault() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },
  triggerAllEvents: function triggerAllEvents() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return value;
  },
  rubberband: function rubberband() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];

      case false:
        return [0, 0];

      default:
        return V.toVector(value);
    }
  },
  from: function from(value) {
    if (typeof value === 'function') return value;
    if (value != null) return V.toVector(value);
  },
  transform: function transform(value, _k, config) {
    var transform = value || config.shared.transform;
    this.hasCustomTransform = !!transform;

    if (process.env.NODE_ENV === 'development') {
      var originalTransform = transform || identity;
      return function (v) {
        var r = originalTransform(v);

        if (!isFinite(r[0]) || !isFinite(r[1])) {
          console.warn("[@use-gesture]: config.transform() must produce a valid result, but it was: [".concat(r[0], ",").concat([1], "]"));
        }

        return r;
      };
    }

    return transform || identity;
  },
  threshold: function threshold(value) {
    return V.toVector(value, 0);
  }
};

if (process.env.NODE_ENV === 'development') {
  Object.assign(commonConfigResolver, {
    domTarget: function domTarget(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `domTarget` option has been renamed to `target`.");
      }

      return NaN;
    },
    lockDirection: function lockDirection(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `lockDirection` option has been merged with `axis`. Use it as in `{ axis: 'lock' }`");
      }

      return NaN;
    },
    initial: function initial(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `initial` option has been renamed to `from`.");
      }

      return NaN;
    }
  });
}

var coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis: function axis(_v, _k, _ref5) {
    var axis = _ref5.axis;
    this.lockDirection = axis === 'lock';
    if (!this.lockDirection) return axis;
  },
  bounds: function bounds() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof value === 'function') {
      return function (state) {
        return coordinatesConfigResolver.bounds(value(state));
      };
    }

    if ('current' in value) {
      return function () {
        return value.current;
      };
    }

    if (typeof HTMLElement === 'function' && value instanceof HTMLElement) {
      return value;
    }

    var _value$left = value.left,
        left = _value$left === void 0 ? -Infinity : _value$left,
        _value$right = value.right,
        right = _value$right === void 0 ? Infinity : _value$right,
        _value$top = value.top,
        top = _value$top === void 0 ? -Infinity : _value$top,
        _value$bottom = value.bottom,
        bottom = _value$bottom === void 0 ? Infinity : _value$bottom;
    return [[left, right], [top, bottom]];
  }
});

var DISPLACEMENT = 10;
var KEYS_DELTA_MAP = {
  ArrowRight: function ArrowRight() {
    var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return [DISPLACEMENT * factor, 0];
  },
  ArrowLeft: function ArrowLeft() {
    var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return [-DISPLACEMENT * factor, 0];
  },
  ArrowUp: function ArrowUp() {
    var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return [0, -DISPLACEMENT * factor];
  },
  ArrowDown: function ArrowDown() {
    var factor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return [0, DISPLACEMENT * factor];
  }
};

var DragEngine = /*#__PURE__*/function (_CoordinatesEngine) {
  _inherits(DragEngine, _CoordinatesEngine);

  var _super2 = _createSuper(DragEngine);

  function DragEngine() {
    var _this2;

    _classCallCheck(this, DragEngine);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "ingKey", 'dragging');

    return _this2;
  }

  _createClass(DragEngine, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(DragEngine.prototype), "reset", this).call(this);

      var state = this.state;
      state._pointerId = undefined;
      state._pointerActive = false;
      state._keyboardActive = false;
      state._preventScroll = false;
      state._delayed = false;
      state.swipe = [0, 0];
      state.tap = false;
      state.canceled = false;
      state.cancel = this.cancel.bind(this);
    }
  }, {
    key: "setup",
    value: function setup() {
      var state = this.state;

      if (state._bounds instanceof HTMLElement) {
        var boundRect = state._bounds.getBoundingClientRect();

        var targetRect = state.currentTarget.getBoundingClientRect();
        var _bounds = {
          left: boundRect.left - targetRect.left + state.offset[0],
          right: boundRect.right - targetRect.right + state.offset[0],
          top: boundRect.top - targetRect.top + state.offset[1],
          bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
        };
        state._bounds = coordinatesConfigResolver.bounds(_bounds);
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this3 = this;

      var state = this.state;
      if (state.canceled) return;
      state.canceled = true;
      state._active = false;
      setTimeout(function () {
        _this3.compute();

        _this3.emit();
      }, 0);
    }
  }, {
    key: "setActive",
    value: function setActive() {
      this.state._active = this.state._pointerActive || this.state._keyboardActive;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.pointerClean();
      this.state._pointerActive = false;
      this.state._keyboardActive = false;

      _get(_getPrototypeOf(DragEngine.prototype), "clean", this).call(this);
    }
  }, {
    key: "pointerDown",
    value: function pointerDown(event) {
      var config = this.config;
      var state = this.state;
      if (event.buttons != null && (Array.isArray(config.pointerButtons) ? !config.pointerButtons.includes(event.buttons) : config.pointerButtons !== -1 && config.pointerButtons !== event.buttons)) return;
      this.ctrl.setEventIds(event);

      if (config.pointerCapture) {
        event.target.setPointerCapture(event.pointerId);
      }

      if (state._pointerActive) return;
      this.start(event);
      this.setupPointer(event);
      state._pointerId = pointerId(event);
      state._pointerActive = true;
      this.computeValues(pointerValues(event));
      this.computeInitial();

      if (config.preventScroll) {
        this.setupScrollPrevention(event);
      } else if (config.delay > 0) {
        this.setupDelayTrigger(event);
      } else {
        this.startPointerDrag(event);
      }
    }
  }, {
    key: "startPointerDrag",
    value: function startPointerDrag(event) {
      var state = this.state;
      state._active = true;
      state._preventScroll = true;
      state._delayed = false;
      this.compute(event);
      this.emit();
    }
  }, {
    key: "pointerMove",
    value: function pointerMove(event) {
      var state = this.state;
      var config = this.config;
      if (!state._pointerActive) return;
      if (state.type === event.type && event.timeStamp === state.timeStamp) return;
      var id = pointerId(event);
      if (state._pointerId && id !== state._pointerId) return;

      var _values = pointerValues(event);

      if (document.pointerLockElement === event.target) {
        state._delta = [event.movementX, event.movementY];
      } else {
        state._delta = V.sub(_values, state._values);
        this.computeValues(_values);
      }

      V.addTo(state._movement, state._delta);
      this.compute(event);

      if (state._delayed) {
        this.timeoutStore.remove('dragDelay');
        state.active = false;
        this.startPointerDrag(event);
        return;
      }

      if (config.preventScroll && !state._preventScroll) {
        if (state.axis) {
          if (state.axis === config.preventScrollAxis || config.preventScrollAxis === 'xy') {
            state._active = false;
            this.clean();
            return;
          } else {
            this.timeoutStore.remove('startPointerDrag');
            this.startPointerDrag(event);
            return;
          }
        } else {
          return;
        }
      }

      this.emit();
    }
  }, {
    key: "pointerUp",
    value: function pointerUp(event) {
      this.ctrl.setEventIds(event);

      try {
        if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) {
          ;
          event.target.releasePointerCapture(event.pointerId);
        }
      } catch (_unused) {
        if (process.env.NODE_ENV === 'development') {
          console.warn("[@use-gesture]: If you see this message, it's likely that you're using an outdated version of `@react-three/fiber`. \n\nPlease upgrade to the latest version.");
        }
      }

      var state = this.state;
      var config = this.config;
      if (!state._pointerActive) return;
      var id = pointerId(event);
      if (state._pointerId && id !== state._pointerId) return;
      this.state._pointerActive = false;
      this.setActive();
      this.compute(event);

      var _state$_distance = _slicedToArray(state._distance, 2),
          dx = _state$_distance[0],
          dy = _state$_distance[1];

      state.tap = dx <= config.tapsThreshold && dy <= config.tapsThreshold;

      if (state.tap && config.filterTaps) {
        state._force = true;
      } else {
        var _state$direction = _slicedToArray(state.direction, 2),
            dirx = _state$direction[0],
            diry = _state$direction[1];

        var _state$velocity = _slicedToArray(state.velocity, 2),
            vx = _state$velocity[0],
            vy = _state$velocity[1];

        var _state$movement = _slicedToArray(state.movement, 2),
            mx = _state$movement[0],
            my = _state$movement[1];

        var _config$swipe$velocit = _slicedToArray(config.swipe.velocity, 2),
            svx = _config$swipe$velocit[0],
            svy = _config$swipe$velocit[1];

        var _config$swipe$distanc = _slicedToArray(config.swipe.distance, 2),
            sx = _config$swipe$distanc[0],
            sy = _config$swipe$distanc[1];

        var sdt = config.swipe.duration;

        if (state.elapsedTime < sdt) {
          if (Math.abs(vx) > svx && Math.abs(mx) > sx) state.swipe[0] = dirx;
          if (Math.abs(vy) > svy && Math.abs(my) > sy) state.swipe[1] = diry;
        }
      }

      this.emit();
    }
  }, {
    key: "pointerClick",
    value: function pointerClick(event) {
      if (!this.state.tap) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "setupPointer",
    value: function setupPointer(event) {
      var config = this.config;
      var device = config.device;

      if (process.env.NODE_ENV === 'development') {
        try {
          if (device === 'pointer') {
            var currentTarget = 'uv' in event ? event.sourceEvent.currentTarget : event.currentTarget;
            var style = window.getComputedStyle(currentTarget);

            if (style.touchAction === 'auto') {
              console.warn("[@use-gesture]: The drag target has its `touch-action` style property set to `auto`. It is recommended to add `touch-action: 'none'` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.\n\nThis message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.", currentTarget);
            }
          }
        } catch (_unused2) {}
      }

      if (config.pointerLock) {
        event.currentTarget.requestPointerLock();
      }

      if (!config.pointerCapture) {
        this.eventStore.add(this.sharedConfig.window, device, 'change', this.pointerMove.bind(this));
        this.eventStore.add(this.sharedConfig.window, device, 'end', this.pointerUp.bind(this));
      }
    }
  }, {
    key: "pointerClean",
    value: function pointerClean() {
      if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
        document.exitPointerLock();
      }
    }
  }, {
    key: "preventScroll",
    value: function preventScroll(event) {
      if (this.state._preventScroll && event.cancelable) {
        event.preventDefault();
      }
    }
  }, {
    key: "setupScrollPrevention",
    value: function setupScrollPrevention(event) {
      persistEvent(event);
      this.eventStore.add(this.sharedConfig.window, 'touch', 'change', this.preventScroll.bind(this), {
        passive: false
      });
      this.eventStore.add(this.sharedConfig.window, 'touch', 'end', this.clean.bind(this), {
        passive: false
      });
      this.eventStore.add(this.sharedConfig.window, 'touch', 'cancel', this.clean.bind(this), {
        passive: false
      });
      this.timeoutStore.add('startPointerDrag', this.startPointerDrag.bind(this), this.config.preventScroll, event);
    }
  }, {
    key: "setupDelayTrigger",
    value: function setupDelayTrigger(event) {
      this.state._delayed = true;
      this.timeoutStore.add('dragDelay', this.startPointerDrag.bind(this), this.config.delay, event);
    }
  }, {
    key: "keyDown",
    value: function keyDown(event) {
      var deltaFn = KEYS_DELTA_MAP[event.key];

      if (deltaFn) {
        var state = this.state;
        var factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
        state._delta = deltaFn(factor);
        this.start(event);
        state._keyboardActive = true;
        V.addTo(state._movement, state._delta);
        this.compute(event);
        this.emit();
      }
    }
  }, {
    key: "keyUp",
    value: function keyUp(event) {
      if (!(event.key in KEYS_DELTA_MAP)) return;
      this.state._keyboardActive = false;
      this.setActive();
      this.compute(event);
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      var device = this.config.device;
      bindFunction(device, 'start', this.pointerDown.bind(this));

      if (this.config.pointerCapture) {
        bindFunction(device, 'change', this.pointerMove.bind(this));
        bindFunction(device, 'end', this.pointerUp.bind(this));
        bindFunction(device, 'cancel', this.pointerUp.bind(this));
        bindFunction('lostPointerCapture', '', this.pointerUp.bind(this));
      }

      bindFunction('key', 'down', this.keyDown.bind(this));
      bindFunction('key', 'up', this.keyUp.bind(this));

      if (this.config.filterTaps) {
        bindFunction('click', '', this.pointerClick.bind(this), {
          capture: true,
          passive: false
        });
      }
    }
  }]);

  return DragEngine;
}(CoordinatesEngine);

function persistEvent(event) {
  'persist' in event && typeof event.persist === 'function' && event.persist();
}

var isBrowser = typeof window !== 'undefined' && window.document && window.document.createElement;

function supportsTouchEvents() {
  return isBrowser && 'ontouchstart' in window;
}

function isTouchScreen() {
  return supportsTouchEvents() || isBrowser && window.navigator.maxTouchPoints > 1;
}

function supportsPointerEvents() {
  return isBrowser && 'onpointerdown' in window;
}

function supportsPointerLock() {
  return isBrowser && 'exitPointerLock' in window.document;
}

function supportsGestureEvents() {
  try {
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}

var SUPPORT = {
  isBrowser: isBrowser,
  gesture: supportsGestureEvents(),
  touch: isTouchScreen(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};
var DEFAULT_PREVENT_SCROLL_DELAY = 250;
var DEFAULT_DRAG_DELAY = 180;
var DEFAULT_SWIPE_VELOCITY = 0.5;
var DEFAULT_SWIPE_DISTANCE = 50;
var DEFAULT_SWIPE_DURATION = 250;

var dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  pointerLock: function pointerLock(_v, _k, _ref6) {
    var _ref6$pointer = _ref6.pointer;
    _ref6$pointer = _ref6$pointer === void 0 ? {} : _ref6$pointer;
    var _ref6$pointer$lock = _ref6$pointer.lock,
        lock = _ref6$pointer$lock === void 0 ? false : _ref6$pointer$lock,
        _ref6$pointer$touch = _ref6$pointer.touch,
        touch = _ref6$pointer$touch === void 0 ? false : _ref6$pointer$touch;
    this.useTouch = touch && SUPPORT.touch;
    return lock && SUPPORT.pointerLock;
  },
  device: function device(_v, _k) {
    if (this.useTouch) return 'touch';
    if (this.pointerLock) return 'mouse';
    if (SUPPORT.pointer) return 'pointer';
    if (SUPPORT.touch) return 'touch';
    return 'mouse';
  },
  preventScroll: function preventScroll() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _k = arguments.length > 1 ? arguments[1] : undefined;

    var _ref7 = arguments.length > 2 ? arguments[2] : undefined,
        _ref7$preventScrollAx = _ref7.preventScrollAxis,
        preventScrollAxis = _ref7$preventScrollAx === void 0 ? 'y' : _ref7$preventScrollAx;

    if (preventScrollAxis) this.preventScrollAxis = preventScrollAxis;
    if (!SUPPORT.touchscreen) return false;
    if (typeof value === 'number') return value;
    return value ? DEFAULT_PREVENT_SCROLL_DELAY : false;
  },
  pointerCapture: function pointerCapture(_v, _k, _ref8) {
    var _ref8$pointer = _ref8.pointer;
    _ref8$pointer = _ref8$pointer === void 0 ? {} : _ref8$pointer;
    var _ref8$pointer$capture = _ref8$pointer.capture,
        capture = _ref8$pointer$capture === void 0 ? true : _ref8$pointer$capture,
        _ref8$pointer$buttons = _ref8$pointer.buttons,
        buttons = _ref8$pointer$buttons === void 0 ? 1 : _ref8$pointer$buttons;
    this.pointerButtons = buttons;
    return !this.pointerLock && this.device === 'pointer' && capture;
  },
  threshold: function threshold(value, _k, _ref9) {
    var _ref9$filterTaps = _ref9.filterTaps,
        filterTaps = _ref9$filterTaps === void 0 ? false : _ref9$filterTaps,
        _ref9$tapsThreshold = _ref9.tapsThreshold,
        tapsThreshold = _ref9$tapsThreshold === void 0 ? 3 : _ref9$tapsThreshold,
        _ref9$axis = _ref9.axis,
        axis = _ref9$axis === void 0 ? undefined : _ref9$axis;
    var threshold = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold;
  },
  swipe: function swipe() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$velocity = _ref10.velocity,
        velocity = _ref10$velocity === void 0 ? DEFAULT_SWIPE_VELOCITY : _ref10$velocity,
        _ref10$distance = _ref10.distance,
        distance = _ref10$distance === void 0 ? DEFAULT_SWIPE_DISTANCE : _ref10$distance,
        _ref10$duration = _ref10.duration,
        duration = _ref10$duration === void 0 ? DEFAULT_SWIPE_DURATION : _ref10$duration;

    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance)),
      duration: duration
    };
  },
  delay: function delay() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;

      case false:
        return 0;

      default:
        return value;
    }
  }
});

if (process.env.NODE_ENV === 'development') {
  Object.assign(dragConfigResolver, {
    useTouch: function useTouch(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `useTouch` option has been renamed to `pointer.touch`. Use it as in `{ pointer: { touch: true } }`.");
      }

      return NaN;
    },
    experimental_preventWindowScrollY: function experimental_preventWindowScrollY(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `experimental_preventWindowScrollY` option has been renamed to `preventScroll`.");
      }

      return NaN;
    },
    swipeVelocity: function swipeVelocity(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeVelocity` option has been renamed to `swipe.velocity`. Use it as in `{ swipe: { velocity: 0.5 } }`.");
      }

      return NaN;
    },
    swipeDistance: function swipeDistance(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeDistance` option has been renamed to `swipe.distance`. Use it as in `{ swipe: { distance: 50 } }`.");
      }

      return NaN;
    },
    swipeDuration: function swipeDuration(value) {
      if (value !== undefined) {
        throw Error("[@use-gesture]: `swipeDuration` option has been renamed to `swipe.duration`. Use it as in `{ swipe: { duration: 250 } }`.");
      }

      return NaN;
    }
  });
}

var SCALE_ANGLE_RATIO_INTENT_DEG = 30;
var PINCH_WHEEL_RATIO = 36;

var PinchEngine = /*#__PURE__*/function (_Engine2) {
  _inherits(PinchEngine, _Engine2);

  var _super3 = _createSuper(PinchEngine);

  function PinchEngine() {
    var _this4;

    _classCallCheck(this, PinchEngine);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this4 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "ingKey", 'pinching');

    _defineProperty(_assertThisInitialized(_this4), "aliasKey", 'da');

    return _this4;
  }

  _createClass(PinchEngine, [{
    key: "init",
    value: function init() {
      this.state.offset = [1, 0];
      this.state.lastOffset = [1, 0];
      this.state._pointerEvents = new Map();
    }
  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(PinchEngine.prototype), "reset", this).call(this);

      var state = this.state;
      state._touchIds = [];
      state.canceled = false;
      state.cancel = this.cancel.bind(this);
      state.turns = 0;
    }
  }, {
    key: "computeOffset",
    value: function computeOffset() {
      var _this$state = this.state,
          type = _this$state.type,
          movement = _this$state.movement,
          lastOffset = _this$state.lastOffset;

      if (type === 'wheel') {
        this.state.offset = V.add(movement, lastOffset);
      } else {
        this.state.offset = [(1 + movement[0]) * lastOffset[0], movement[1] + lastOffset[1]];
      }
    }
  }, {
    key: "computeMovement",
    value: function computeMovement() {
      var _this$state2 = this.state,
          offset = _this$state2.offset,
          lastOffset = _this$state2.lastOffset;
      this.state.movement = [offset[0] / lastOffset[0], offset[1] - lastOffset[1]];
    }
  }, {
    key: "intent",
    value: function intent(v) {
      var state = this.state;

      if (!state.axis) {
        var axisMovementDifference = Math.abs(v[0]) * SCALE_ANGLE_RATIO_INTENT_DEG - Math.abs(v[1]);
        if (axisMovementDifference < 0) state.axis = 'angle';else if (axisMovementDifference > 0) state.axis = 'scale';
      }

      if (this.config.lockDirection) {
        if (state.axis === 'scale') v[1] = 0;else if (state.axis === 'angle') v[0] = 0;
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      var _this5 = this;

      var state = this.state;
      if (state.canceled) return;
      setTimeout(function () {
        state.canceled = true;
        state._active = false;

        _this5.compute();

        _this5.emit();
      }, 0);
    }
  }, {
    key: "touchStart",
    value: function touchStart(event) {
      this.ctrl.setEventIds(event);
      var state = this.state;
      var ctrlTouchIds = this.ctrl.touchIds;

      if (state._active) {
        if (state._touchIds.every(function (id) {
          return ctrlTouchIds.has(id);
        })) return;
      }

      if (ctrlTouchIds.size < 2) return;
      this.start(event);
      state._touchIds = Array.from(ctrlTouchIds).slice(0, 2);
      var payload = touchDistanceAngle(event, state._touchIds);
      this.pinchStart(event, payload);
    }
  }, {
    key: "pointerStart",
    value: function pointerStart(event) {
      if (event.buttons != null && event.buttons % 2 !== 1) return;
      this.ctrl.setEventIds(event);
      event.target.setPointerCapture(event.pointerId);
      var state = this.state;
      var _pointerEvents = state._pointerEvents;
      var ctrlPointerIds = this.ctrl.pointerIds;

      if (state._active) {
        if (Array.from(_pointerEvents.keys()).every(function (id) {
          return ctrlPointerIds.has(id);
        })) return;
      }

      if (_pointerEvents.size < 2) {
        _pointerEvents.set(event.pointerId, event);
      }

      if (state._pointerEvents.size < 2) return;
      this.start(event);
      var payload = distanceAngle.apply(void 0, _toConsumableArray(Array.from(_pointerEvents.values())));
      this.pinchStart(event, payload);
    }
  }, {
    key: "pinchStart",
    value: function pinchStart(event, payload) {
      var state = this.state;
      state.origin = payload.origin;
      this.computeValues([payload.distance, payload.angle]);
      this.computeInitial();
      this.compute(event);
      this.emit();
    }
  }, {
    key: "touchMove",
    value: function touchMove(event) {
      if (!this.state._active) return;
      var payload = touchDistanceAngle(event, this.state._touchIds);
      this.pinchMove(event, payload);
    }
  }, {
    key: "pointerMove",
    value: function pointerMove(event) {
      var _pointerEvents = this.state._pointerEvents;

      if (_pointerEvents.has(event.pointerId)) {
        _pointerEvents.set(event.pointerId, event);
      }

      if (!this.state._active) return;
      var payload = distanceAngle.apply(void 0, _toConsumableArray(Array.from(_pointerEvents.values())));
      this.pinchMove(event, payload);
    }
  }, {
    key: "pinchMove",
    value: function pinchMove(event, payload) {
      var state = this.state;
      var prev_a = state._values[1];
      var delta_a = payload.angle - prev_a;
      var delta_turns = 0;
      if (Math.abs(delta_a) > 270) delta_turns += Math.sign(delta_a);
      this.computeValues([payload.distance, payload.angle - 360 * delta_turns]);
      state.origin = payload.origin;
      state.turns = delta_turns;
      state._movement = [state._values[0] / state._initial[0] - 1, state._values[1] - state._initial[1]];
      this.compute(event);
      this.emit();
    }
  }, {
    key: "touchEnd",
    value: function touchEnd(event) {
      var _this6 = this;

      this.ctrl.setEventIds(event);
      if (!this.state._active) return;

      if (this.state._touchIds.some(function (id) {
        return !_this6.ctrl.touchIds.has(id);
      })) {
        this.state._active = false;
        this.compute(event);
        this.emit();
      }
    }
  }, {
    key: "pointerEnd",
    value: function pointerEnd(event) {
      var state = this.state;
      this.ctrl.setEventIds(event);

      try {
        event.target.releasePointerCapture(event.pointerId);
      } catch (_unused) {}

      if (state._pointerEvents.has(event.pointerId)) {
        state._pointerEvents.delete(event.pointerId);
      }

      if (!state._active) return;

      if (state._pointerEvents.size < 2) {
        state._active = false;
        this.compute(event);
        this.emit();
      }
    }
  }, {
    key: "gestureStart",
    value: function gestureStart(event) {
      if (event.cancelable) event.preventDefault();
      var state = this.state;
      if (state._active) return;
      this.start(event);
      this.computeValues([event.scale, event.rotation]);
      state.origin = [event.clientX, event.clientY];
      this.compute(event);
      this.emit();
    }
  }, {
    key: "gestureMove",
    value: function gestureMove(event) {
      if (event.cancelable) event.preventDefault();
      if (!this.state._active) return;
      var state = this.state;
      this.computeValues([event.scale, event.rotation]);
      state.origin = [event.clientX, event.clientY];
      var _previousMovement = state._movement;
      state._movement = [event.scale - 1, event.rotation];
      state._delta = V.sub(state._movement, _previousMovement);
      this.compute(event);
      this.emit();
    }
  }, {
    key: "gestureEnd",
    value: function gestureEnd(event) {
      if (!this.state._active) return;
      this.state._active = false;
      this.compute(event);
      this.emit();
    }
  }, {
    key: "wheel",
    value: function wheel(event) {
      if (!event.ctrlKey) return;
      if (!this.state._active) this.wheelStart(event);else this.wheelChange(event);
      this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
  }, {
    key: "wheelStart",
    value: function wheelStart(event) {
      this.start(event);
      this.wheelChange(event);
    }
  }, {
    key: "wheelChange",
    value: function wheelChange(event) {
      var isR3f = ('uv' in event);

      if (!isR3f) {
        if (event.cancelable) {
          event.preventDefault();
        }

        if (process.env.NODE_ENV === 'development' && !event.defaultPrevented) {
          console.warn("[@use-gesture]: To properly support zoom on trackpads, try using the `target` option.\n\nThis message will only appear in development mode.");
        }
      }

      var state = this.state;
      state._delta = [-wheelValues(event)[1] / PINCH_WHEEL_RATIO * state.offset[0], 0];
      V.addTo(state._movement, state._delta);
      this.state.origin = [event.clientX, event.clientY];
      this.compute(event);
      this.emit();
    }
  }, {
    key: "wheelEnd",
    value: function wheelEnd() {
      if (!this.state._active) return;
      this.state._active = false;
      this.compute();
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      var device = this.config.device;

      if (!!device) {
        bindFunction(device, 'start', this[device + 'Start'].bind(this));
        bindFunction(device, 'change', this[device + 'Move'].bind(this));
        bindFunction(device, 'end', this[device + 'End'].bind(this));
        bindFunction(device, 'cancel', this[device + 'End'].bind(this));
      } else {
        bindFunction('wheel', '', this.wheel.bind(this), {
          passive: false
        });
      }
    }
  }]);

  return PinchEngine;
}(Engine);

var pinchConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  useTouch: function useTouch(_v, _k, _ref11) {
    var _ref11$pointer = _ref11.pointer;
    _ref11$pointer = _ref11$pointer === void 0 ? {} : _ref11$pointer;
    var _ref11$pointer$touch = _ref11$pointer.touch,
        touch = _ref11$pointer$touch === void 0 ? false : _ref11$pointer$touch;
    return touch && SUPPORT.touch;
  },
  device: function device(_v, _k, config) {
    var sharedConfig = config.shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture) return 'gesture';
    if (this.useTouch) return 'touch';

    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer) return 'pointer';
      if (SUPPORT.touch) return 'touch';
    }
  },
  bounds: function bounds(_v, _k, _ref12) {
    var _ref12$scaleBounds = _ref12.scaleBounds,
        scaleBounds = _ref12$scaleBounds === void 0 ? {} : _ref12$scaleBounds,
        _ref12$angleBounds = _ref12.angleBounds,
        angleBounds = _ref12$angleBounds === void 0 ? {} : _ref12$angleBounds;

    var _scaleBounds = function _scaleBounds(state) {
      var D = assignDefault(call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D.min, D.max];
    };

    var _angleBounds = function _angleBounds(state) {
      var A = assignDefault(call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    };

    if (typeof scaleBounds !== 'function' && typeof angleBounds !== 'function') return [_scaleBounds(), _angleBounds()];
    return function (state) {
      return [_scaleBounds(state), _angleBounds(state)];
    };
  },
  threshold: function threshold(value, _k, config) {
    this.lockDirection = config.axis === 'lock';
    var threshold = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold;
  }
});

var MoveEngine = /*#__PURE__*/function (_CoordinatesEngine2) {
  _inherits(MoveEngine, _CoordinatesEngine2);

  var _super4 = _createSuper(MoveEngine);

  function MoveEngine() {
    var _this7;

    _classCallCheck(this, MoveEngine);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this7), "ingKey", 'moving');

    return _this7;
  }

  _createClass(MoveEngine, [{
    key: "move",
    value: function move(event) {
      if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
      if (!this.state._active) this.moveStart(event);else this.moveChange(event);
      this.timeoutStore.add('moveEnd', this.moveEnd.bind(this));
    }
  }, {
    key: "moveStart",
    value: function moveStart(event) {
      this.start(event);
      this.computeValues(pointerValues(event));
      this.compute(event);
      this.computeInitial();
      this.emit();
    }
  }, {
    key: "moveChange",
    value: function moveChange(event) {
      if (!this.state._active) return;
      var values = pointerValues(event);
      var state = this.state;
      state._delta = V.sub(values, state._values);
      V.addTo(state._movement, state._delta);
      this.computeValues(values);
      this.compute(event);
      this.emit();
    }
  }, {
    key: "moveEnd",
    value: function moveEnd(event) {
      if (!this.state._active) return;
      this.state._active = false;
      this.compute(event);
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      bindFunction('pointer', 'change', this.move.bind(this));
      bindFunction('pointer', 'leave', this.moveEnd.bind(this));
    }
  }]);

  return MoveEngine;
}(CoordinatesEngine);

var moveConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: function mouseOnly() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }
});

var ScrollEngine = /*#__PURE__*/function (_CoordinatesEngine3) {
  _inherits(ScrollEngine, _CoordinatesEngine3);

  var _super5 = _createSuper(ScrollEngine);

  function ScrollEngine() {
    var _this8;

    _classCallCheck(this, ScrollEngine);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this8 = _super5.call.apply(_super5, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this8), "ingKey", 'scrolling');

    return _this8;
  }

  _createClass(ScrollEngine, [{
    key: "scroll",
    value: function scroll(event) {
      if (!this.state._active) this.start(event);
      this.scrollChange(event);
      this.timeoutStore.add('scrollEnd', this.scrollEnd.bind(this));
    }
  }, {
    key: "scrollChange",
    value: function scrollChange(event) {
      if (event.cancelable) event.preventDefault();
      var state = this.state;
      var values = scrollValues(event);
      state._delta = V.sub(values, state._values);
      V.addTo(state._movement, state._delta);
      this.computeValues(values);
      this.compute(event);
      this.emit();
    }
  }, {
    key: "scrollEnd",
    value: function scrollEnd() {
      if (!this.state._active) return;
      this.state._active = false;
      this.compute();
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      bindFunction('scroll', '', this.scroll.bind(this));
    }
  }]);

  return ScrollEngine;
}(CoordinatesEngine);

var scrollConfigResolver = coordinatesConfigResolver;

var WheelEngine = /*#__PURE__*/function (_CoordinatesEngine4) {
  _inherits(WheelEngine, _CoordinatesEngine4);

  var _super6 = _createSuper(WheelEngine);

  function WheelEngine() {
    var _this9;

    _classCallCheck(this, WheelEngine);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this9 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this9), "ingKey", 'wheeling');

    return _this9;
  }

  _createClass(WheelEngine, [{
    key: "wheel",
    value: function wheel(event) {
      if (!this.state._active) this.start(event);
      this.wheelChange(event);
      this.timeoutStore.add('wheelEnd', this.wheelEnd.bind(this));
    }
  }, {
    key: "wheelChange",
    value: function wheelChange(event) {
      var state = this.state;
      state._delta = wheelValues(event);
      V.addTo(state._movement, state._delta);

      var _state$overflow = _slicedToArray(state.overflow, 2),
          ox = _state$overflow[0],
          oy = _state$overflow[1];

      var _state$_delta = _slicedToArray(state._delta, 2),
          dx = _state$_delta[0],
          dy = _state$_delta[1];

      var _state$_direction = _slicedToArray(state._direction, 2),
          dirx = _state$_direction[0],
          diry = _state$_direction[1];

      if (ox < 0 && dx > 0 && dirx < 0 || ox > 0 && dx < 0 && dirx > 0) {
        state._movement[0] = state._movementBound[0];
      }

      if (oy < 0 && dy > 0 && diry < 0 || oy > 0 && dy < 0 && diry > 0) {
        state._movement[1] = state._movementBound[1];
      }

      this.compute(event);
      this.emit();
    }
  }, {
    key: "wheelEnd",
    value: function wheelEnd() {
      if (!this.state._active) return;
      this.state._active = false;
      this.compute();
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      bindFunction('wheel', '', this.wheel.bind(this));
    }
  }]);

  return WheelEngine;
}(CoordinatesEngine);

var wheelConfigResolver = coordinatesConfigResolver;

var HoverEngine = /*#__PURE__*/function (_CoordinatesEngine5) {
  _inherits(HoverEngine, _CoordinatesEngine5);

  var _super7 = _createSuper(HoverEngine);

  function HoverEngine() {
    var _this10;

    _classCallCheck(this, HoverEngine);

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    _this10 = _super7.call.apply(_super7, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this10), "ingKey", 'hovering');

    return _this10;
  }

  _createClass(HoverEngine, [{
    key: "enter",
    value: function enter(event) {
      if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
      this.start(event);
      this.computeValues(pointerValues(event));
      this.compute(event);
      this.emit();
    }
  }, {
    key: "leave",
    value: function leave(event) {
      if (this.config.mouseOnly && event.pointerType !== 'mouse') return;
      var state = this.state;
      if (!state._active) return;
      state._active = false;
      var values = pointerValues(event);
      state._movement = state._delta = V.sub(values, state._values);
      this.computeValues(values);
      this.compute(event);
      state.delta = state.movement;
      this.emit();
    }
  }, {
    key: "bind",
    value: function bind(bindFunction) {
      bindFunction('pointer', 'enter', this.enter.bind(this));
      bindFunction('pointer', 'leave', this.leave.bind(this));
    }
  }]);

  return HoverEngine;
}(CoordinatesEngine);

var hoverConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: function mouseOnly() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return value;
  }
});

var EngineMap = new Map();
var ConfigResolverMap = new Map();

function registerAction(action) {
  EngineMap.set(action.key, action.engine);
  ConfigResolverMap.set(action.key, action.resolver);
}

var dragAction = {
  key: 'drag',
  engine: DragEngine,
  resolver: dragConfigResolver
};
var hoverAction = {
  key: 'hover',
  engine: HoverEngine,
  resolver: hoverConfigResolver
};
var moveAction = {
  key: 'move',
  engine: MoveEngine,
  resolver: moveConfigResolver
};
var pinchAction = {
  key: 'pinch',
  engine: PinchEngine,
  resolver: pinchConfigResolver
};
var scrollAction = {
  key: 'scroll',
  engine: ScrollEngine,
  resolver: scrollConfigResolver
};
var wheelAction = {
  key: 'wheel',
  engine: WheelEngine,
  resolver: wheelConfigResolver
};
export { ConfigResolverMap as C, EngineMap as E, SUPPORT as S, _objectSpread2 as _, _defineProperty as a, touchIds as b, chain as c, toHandlerProp as d, dragAction as e, pinchAction as f, hoverAction as h, isTouch as i, moveAction as m, parseProp as p, registerAction as r, scrollAction as s, toDomEventType as t, wheelAction as w };